import { ActivitySummaryResponseBuilder } from './ActivitySummaryResponseBuilder';
import { ImageResponseBuilder } from './ImageResponseBuilder';
import { ReviewSummaryResponseBuilder } from './ReviewSummaryResponseBuilder';
import { DetailResponseBuilder } from './DetailResponseBuilder';
import { BadgesResponseBuilder } from './BadgesResponseBuilder';
import { HighlightResponseBuilder } from './HighlightResponseBuilder';
import { SupportedLanguagesResponseBuilder } from './SupportedLanguagesResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class ContentResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('Content');
    }
    public withActivity = (builder: ActivitySummaryResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activity'] = this.initField(builder, args);
        return this;
    }

    public withImages = (builder: ImageResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['images'] = this.initField(builder, args);
        return this;
    }

    public withReviewSummary = (builder: ReviewSummaryResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['reviewSummary'] = this.initField(builder, args);
        return this;
    }

    public withDetail = (builder: DetailResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['detail'] = this.initField(builder, args);
        return this;
    }

    public withContentLanguage = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['contentLanguage'] = this.initField(null, args);
        return this;
    }

    public withContentLocale = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['contentLocale'] = this.initField(null, args);
        return this;
    }

    public withBadges = (builder: BadgesResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['badges'] = this.initField(builder, args);
        return this;
    }

    public withActivityHighlights = (builder: HighlightResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityHighlights'] = this.initField(builder, args);
        return this;
    }

    public withSupportedLanguages = (builder: SupportedLanguagesResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supportedLanguages'] = this.initField(builder, args);
        return this;
    }
}
